<template>
  <div>
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-bell"></i>
          Q &amp; A
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">Board</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Q &amp; A</a>
          </li>
      </ul>
    </div>
    <b-card>
      <!-- <div slot="header">
        <strong>Q &amp; A</strong>
        <small> ({{model.created_at | sdate}})</small>
      </div> -->
      <b-row>
        <b-col class="title">
          Q &amp; A
        </b-col>
        <b-col>
          <span class="float-right font_13" v-if="!add">{{model.created_at | sdate}}</span>
        </b-col>
      </b-row>
      <!-- <hr>
      <b-row>
        <b-col>
          <b-input class="title" md="5" type="text" v-model="model.title" :plaintext="lock"></b-input>
        </b-col>
        <b-col>
          <span class="float-right font_13" v-if="!add">{{model.created_at | sdate}}</span>
        </b-col>
      </b-row> -->
      <hr>
      <b-row class="mb-2">
        <b-col md="2" class="col-form-label">
          カテゴリー
        </b-col>
        <b-col>
          <!-- <b-input type="text" v-model="codes.BOARD_TYPE[model.type]" :disabled="lock"></b-input> -->
          <select v-model="model.type" class="w-100" :disabled="lock">
            <option disabled value="">サービスを選択してください</option>
            <option value="webcastle">WEBCastle : Web Firewall</option>
            <option value="wsfinder">WSFinder : Anti-Webshell</option>
            <option value="wmds">WMDS : Web Malware Detection System</option>
            <option value="wfdetector">WFDetector : Web Forgery Detection</option>
            <option value="etc">Etc</option>
          </select>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col md="2" class="col-form-label">
          タイトル <span class="text-danger ml-1">*</span>
        </b-col>
        <b-col>
          <b-input type="text" v-model="model.title" :disabled="lock"></b-input>
        </b-col>
      </b-row>

      <hr>

      <b-row class="mb-2">
        <b-col class="title_sub">
          質問
        </b-col>
      </b-row>
      <!-- <hr> -->
      <b-row class="mb-2">
        <b-col>
          <div v-if="lock" class="ql-editor ql-snow" v-html="model.question"></div>
          <vue-editor v-else v-model="model.question" id="ph_question"></vue-editor>
        </b-col>
      </b-row>
      <b-row v-if="!add || model.is_answered" class="mb-2">
        <b-col class="title_sub">
          回答
          <span v-if="!model.is_answered" class="font_14">
            (今のところ回答はありません)
          </span>
        </b-col>
      </b-row>
      <!-- <hr> -->
      <b-row v-if="!add || model.is_answered" class="mb-2">
        <b-col>
          <div class="ql-editor ql-snow" v-html="model.answer"></div>
        </b-col>
      </b-row>
      <hr>
      <!-- <b-form-group>
        <label for="ph_title">サービス</label>
        <select v-model="model.type" class="w-100" :disabled="lock">
          <option disabled value="">サービスを選択してください</option>
          <option value="webcastle">WEBCastle : Web Firewall</option>
          <option value="wsfinder">WSFinder : Anti-Webshell</option>
          <option value="wmds">WMDS : Web Malware Detection System</option>
          <option value="wfdetector">WFDetector : Web Forgery Detection</option>
          <option value="etc">Etc</option>
        </select>
      </b-form-group> -->
      <!-- <b-form-group class="text-primary">
        <label for="ph_title">タイトル</label>
        <b-input md="5" type="text" id="ph_title" v-model="model.title" :plaintext="lock"></b-input>
      </b-form-group> -->
      <!-- <b-form-group v-if="model.user">
        <label for="ph_from" class="text-primary">From</label>
        <div>
          [{{model.group.groupname}}] {{model.user.nickname}}
          <router-link :to="{ name: 'user', params: { id: model.user_id } }"><b-button size="sm" variant="secondary" v-if="auth.profile.permissions == 'Owner'">Info</b-button></router-link>
        </div>
      </b-form-group> -->
      <!-- <b-form-group>
        <label for="ph_question" class="text-primary">質問</label>
        <div v-if="lock" class="ql-editor ql-snow" v-html="model.question"></div>
        <vue-editor v-else v-model="model.question" id="ph_question"></vue-editor>
      </b-form-group> -->
      <!-- <b-form-group v-if="model.is_answered">
        <label for="ph_answer" class="text-primary">回答</label>
        <div class="ql-editor ql-snow" v-html="model.answer"></div>
      </b-form-group> -->



      <b-row>
        <b-col md="10">
          <template v-if="lock">
            <b-button size="sm" variant="primary" :disabled="model.answer && model.answer.length > 0" @click="edit" class="btn-add"> 修正 </b-button>
              <b-button size="sm" variant="danger" @click="confirm = true"> 削除 </b-button>
          </template>
          <template v-else>
            <b-button class="btn-add" size="sm" variant="success" @click="save"> 保存 </b-button>
            <b-button v-if="!add" size="sm" variant="secondary" @click="cancel" class="btn-cancel"> キャンセル </b-button>
          </template>
        </b-col>
        <b-col md="2" class="text-right">
          <b-button class="btn-addition" size="sm" variant="secondary" @click="back"> リスト </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-modal title="Q&Aが削除されました" class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      削除されたデータは元に戻せません。本当に削除してよろしいですか？
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
